module.exports = __webpack_public_path__ + "static/media/contenedores-03.3234778b.png";